const EmptyLayout = () => import("@/components/layouts/EmptyLayout.vue");
const ImportedOrdersFiles = () => import("./views/ImportedOrdersFiles.vue");
const ImportedOrdersFile = () => import("./views/ImportedOrdersFile.vue");

export default [
  {
    path: "/importedOrdersFiles",
    name: "importedOrdersFiles",
    component: EmptyLayout,

    meta: {
      roles: ["ROLE_ADMIN"],
    },

    children: [
      {
        path: "",
        name: "importedOrdersFiles.list",
        component: ImportedOrdersFiles,

        meta: {
          roles: ["ROLE_ADMIN"],
        },
      },

      {
        path: ":importedOrdersFileId",
        name: "importedOrdersFiles.details",
        component: ImportedOrdersFile,

        meta: {
          roles: ["ROLE_ADMIN"],
        },
      },
    ],
  },
];
